var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/user-edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/user-edit_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.50016 9.03133C6.25475 9.03133 4.42725 7.20383 4.42725 4.95841C4.42725 2.713 6.25475 0.885498 8.50016 0.885498C10.7456 0.885498 12.5731 2.713 12.5731 4.95841C12.5731 7.20383 10.7456 9.03133 8.50016 9.03133ZM8.50016 1.948C6.84266 1.948 5.48975 3.30091 5.48975 4.95841C5.48975 6.61591 6.84266 7.96883 8.50016 7.96883C10.1577 7.96883 11.5106 6.61591 11.5106 4.95841C11.5106 3.30091 10.1577 1.948 8.50016 1.948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.2059 16.1146C10.9367 16.1146 10.6817 16.0155 10.4975 15.8313C10.2779 15.6117 10.1788 15.293 10.2284 14.9601L10.3629 14.0038C10.3984 13.7559 10.5471 13.4655 10.7242 13.2813L13.2317 10.7738C14.2375 9.76799 15.1229 10.3417 15.555 10.7738C15.9234 11.1422 16.1146 11.5388 16.1146 11.9355C16.1146 12.3392 15.9304 12.7146 15.555 13.09L13.0475 15.5976C12.8704 15.7747 12.5729 15.9234 12.325 15.9588L11.3688 16.0934C11.3121 16.1075 11.2625 16.1146 11.2059 16.1146ZM14.3863 11.2767C14.2588 11.2767 14.1454 11.3617 13.9825 11.5247L11.475 14.0321C11.4538 14.0534 11.4183 14.1242 11.4183 14.1525L11.2909 15.038L12.1763 14.9105C12.2046 14.9034 12.2754 14.868 12.2967 14.8467L14.8042 12.3392C14.9175 12.2259 15.0521 12.063 15.0521 11.9355C15.0521 11.8292 14.9671 11.6805 14.8042 11.5247C14.6342 11.3547 14.5067 11.2767 14.3863 11.2767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.8183 13.6141C14.7687 13.6141 14.7191 13.6071 14.6766 13.5929C13.7416 13.3308 12.9978 12.5871 12.7358 11.6521C12.6578 11.3687 12.8208 11.0783 13.1041 11.0004C13.3874 10.9225 13.6778 11.0854 13.7558 11.3687C13.9187 11.9495 14.3791 12.41 14.9599 12.5729C15.2433 12.6508 15.4062 12.9483 15.3283 13.2245C15.2645 13.4583 15.052 13.6141 14.8183 13.6141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.41553 16.1146C2.12511 16.1146 1.88428 15.8738 1.88428 15.5833C1.88428 12.5588 4.85221 10.0938 8.50013 10.0938C9.27221 10.0938 10.0372 10.2071 10.7526 10.4196C11.036 10.5046 11.1918 10.8021 11.1068 11.0783C11.0218 11.3617 10.7243 11.5175 10.448 11.4325C9.82471 11.2483 9.17305 11.1492 8.50013 11.1492C5.44013 11.1492 2.94678 13.1325 2.94678 15.5762C2.94678 15.8737 2.70594 16.1146 2.41553 16.1146Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEdit);
export default __webpack_public_path__ + "static/media/user-edit.13a0f2ae22607f629116e23748c39054.svg";
export { ForwardRef as ReactComponent };